module.exports = __webpack_public_path__ + "static/media/loading.f901d6cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/loading.svg
// module id = 863
// module chunks = 21